import ElementPlus from 'element-plus'
import locale from 'element-plus/lib/locale/lang/en'
import 'element-plus/lib/theme-chalk/index.css'
// style overrides
import '../css/element-custom.css'

export default {
  install: app => {
    app.use(ElementPlus, { locale })
  }
}
